import Restaurants from './Restaurants';

export default Restaurants;
export { default as RestaurantsNew } from './New';
